import { assign as v, strlen as w, charat as h, trim as x, from as y, substr as j, append as q } from "./index.es345.js";
var u = 1, n = 1, p = 0, a = 0, r = 0, c = "";
function z(e, s, m, g, b, d, k, $) {
  return { value: e, root: s, parent: m, type: g, props: b, children: d, line: u, column: n, length: k, return: "", siblings: $ };
}
function D(e, s) {
  return v(z("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, s);
}
function I(e) {
  for (; e.root; )
    e = D(e.root, { children: [e] });
  q(e, e.siblings);
}
function J() {
  return r;
}
function K() {
  return r = a > 0 ? h(c, --a) : 0, n--, r === 10 && (n = 1, u--), r;
}
function t() {
  return r = a < p ? h(c, a++) : 0, n++, r === 10 && (n = 1, u++), r;
}
function i() {
  return h(c, a);
}
function F() {
  return a;
}
function o(e, s) {
  return j(c, e, s);
}
function l(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function L(e) {
  return u = n = 1, p = w(c = e), a = 0, [];
}
function M(e) {
  return c = "", e;
}
function N(e) {
  return x(o(a - 1, f(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function O(e) {
  for (; (r = i()) && r < 33; )
    t();
  return l(e) > 2 || l(r) > 3 ? "" : " ";
}
function A(e, s) {
  for (; --s && t() && !(r < 48 || r > 102 || r > 57 && r < 65 || r > 70 && r < 97); )
    ;
  return o(e, F() + (s < 6 && i() == 32 && t() == 32));
}
function f(e) {
  for (; t(); )
    switch (r) {
      // ] ) " '
      case e:
        return a;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && f(r);
        break;
      // (
      case 40:
        e === 41 && f(e);
        break;
      // \
      case 92:
        t();
        break;
    }
  return a;
}
function B(e, s) {
  for (; t() && e + r !== 57 && !(e + r === 84 && i() === 47); )
    ;
  return "/*" + o(s, a - 1) + "*" + y(e === 47 ? e : t());
}
function C(e) {
  for (; !l(i()); )
    t();
  return o(e, a);
}
export {
  L as alloc,
  F as caret,
  J as char,
  r as character,
  c as characters,
  n as column,
  B as commenter,
  D as copy,
  M as dealloc,
  N as delimit,
  f as delimiter,
  A as escaping,
  C as identifier,
  p as length,
  I as lift,
  u as line,
  t as next,
  z as node,
  i as peek,
  a as position,
  K as prev,
  o as slice,
  l as token,
  O as whitespace
};
//# sourceMappingURL=index.es346.js.map
